/**
 * The app's single auth-aware network client: injects the Firebase ID token,
 * refreshes it and retries once on 401. Token lookup is lazy, so module scope
 * is safe. Share this instance rather than constructing new ones.
 */

import { FirebaseAuthNetworkService } from '@sudobility/auth_lib';

export const authNetworkClient = new FirebaseAuthNetworkService();
